import { Flex, ActionIcon, CSSProperties, Text } from '@mantine/core';
import { MyIcon } from '@web/common-ui';
import { useNavigateBack } from '../../../../hooks';
import classes from './Breadcrumbs.module.css';

export const Breadcrumbs = ({
  path,
  style,
}: {
  path: string;
  style?: CSSProperties;
}) => {
  const navigateBack = useNavigateBack();
  return (
    <Flex className={classes.container} style={style}>
      <ActionIcon variant="white" onClick={navigateBack}>
        <MyIcon name="arrow_back" />
      </ActionIcon>
      <MyIcon name="home" style={{ fill: '#000', marginBottom: 2 }} />
      <Text lh="20px">{path}</Text>
    </Flex>
  );
};
